import Browser from '@mindful-web/marko-web/browser';
import Shared from '@allured-business-media/package-shared/browser';

Shared(Browser);

export default Browser;
